module.exports = __webpack_public_path__ + "static/scale-model-of-national-automobile-museum-in-reno-nevada-e91a1bb0e17359e1d94d26fdc22435ec.png";